// extracted by mini-css-extract-plugin
export var carrierIcon = "_yp-0";
export var carrierLogo = "_yp-1";
export var detailsSection = "_yp-2";